export default {
  None: "None",
  Data: "Data",
  Screen: "Screen",
  Camera: "Camera",
  Audio: "Audio",
};
